// extracted by mini-css-extract-plugin
module.exports = {"productInfoBannerContainer":"styles_productInfoBannerContainer___elIC","textContainer":"styles_textContainer__yPFPw"};